import Vue from 'vue';
import uuid from '@/libs/uuid'

export default Vue.extend({
  props: {
    list: {
      Type: Array
    },
    multiple: {
      Type: Boolean,
      default: false
    },
  },
  data() {
    return {
      id: undefined,
      value: [],
      data: [], 
      loading: false,
      filterable: true,
      remote: true,
      reserveKeyword: false
    }
  },
  watch: {
    value: {
      deep: true,
      immediate: true,
      handler(value) {
        if(value) {
          this.$emit('input', value);
        }
      }
    }
  },
  created() {
    this.id = uuid()
  },
  methods: {
    remoteMethod(query) {
      if (query !== '') {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.data = this.list.filter(item => {
            return item.value.toLowerCase()
              .indexOf(query.toLowerCase()) > -1;
          });
        }, 200);
      } else {
        this.data = [];
      }
      
    },
  },
    template: 
    `
    <div>
      <el-select
        v-model="value"
        :multiple="multiple"
        :filterable="filterable"
        :remote="remote"
        :reserve-keyword="reserveKeyword"
        placeholder="검색 키워드 입력"
        :remote-method="remoteMethod"
        :loading="loading">
        <el-option
          v-for="item in data"
          :key="item.value"
          :value="item.value">
        </el-option>
      </el-select>
    </div>
    `,
});